import { render } from "./ExperienceDescription.vue?vue&type=template&id=1f117d58&scoped=true"
import script from "./ExperienceDescription.vue?vue&type=script&lang=js"
export * from "./ExperienceDescription.vue?vue&type=script&lang=js"

import "./ExperienceDescription.vue?vue&type=style&index=0&id=1f117d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f117d58"]])

export default __exports__